<template>
  <TheNuxtLink
    :to="`/${locale}/marketplace`"
    :class="logoClass"
    :title="t('meta.title')"
    data-test="header__logo-link"
    class="relative block overflow-hidden"
  >
    <img
      v-if="isCN"
      src="@/assets/images/logo-cn.webp"
      alt="logo"
      loading="lazy"
      class="pointer-events-none absolute left-0 top-0 block h-full w-full object-contain"
    />
    <IconLogoWise
      v-else
      class="pointer-events-none absolute left-0 top-0 block h-full w-full object-contain"
    />
  </TheNuxtLink>
</template>

<script setup lang="ts">
  const { t, locale } = useI18n();
  const { isCN } = useLanguage();

  const logoClass = computed((): string => {
    if (isCN.value) {
      return 'tablet:w-[120px] w-[107px] mr-16 tablet:h-[50px] h-[40px]';
    }
    return 'tablet:w-[98px] w-[78px] mr-4 tablet:h-[50px] h-[40px]';
  });
</script>
